import { instance } from './api';

export const foldersAPI = {
    async addElementToFolder(folderId: number, elementId: number, segmentId: number): Promise<any> {
        const response = await instance.post<any>(
            `/data/notification/folder/${folderId}/add/element/${elementId}/segment/${segmentId}`,
            {},
        );
        return response.data?.inserted;
    },
    async removeElementFromFolder(folderId: number, elementId: number, segmentId: number): Promise<any> {
        const response = await instance.post<any>(
            `/data/notification/folder/${folderId}/remove/element/${elementId}/segment/${segmentId}`,
            {},
        );
        return response.data?.remove;
    },
    async addElementToFavorite(favoriteId: number, elementId: number, segmentId: number): Promise<any> {
        const response = await instance.post<any>(`/data/notification/favorite/${favoriteId}/element/form`, {
            element_id: elementId,
            segment_id: segmentId,
        });
        return response.data;
    },
    async changeTilesOrder(
        categoryId: number,
        favoriteId: number,
        folderId: number,
        udeiId: string,
        nextUdeiId: string,
    ): Promise<any> {
        const response = await instance.post<any>(`/data/home/index/change-tiles-order`, {
            category_id: categoryId,
            favorite_id: favoriteId,
            folder_id: folderId,
            udei_id: udeiId,
            pos_udei_id: nextUdeiId,
        });
        return response.data;
    },
};
